/** hr 会议签到 **/
import Layout from "@/views/layout/Layout";
const adminManRouter = {
  path: "/adminMan",
  component: Layout,
  redirect: "/adminMan/flowChart/list",
  name: "adminMan",
  meta: {
    title: "行政管理",
    icon: "clipboard",
    roles: ["xingzhengguanli"]
  },
  alwaysShow: true,
  children: [
    {
      path: "noticeAnnouncement",
      name: "通知公告",
      component: () => import("@/views/platformManSystem/noticeAnnouncement"),
      meta: {
        title: "通知公告",
        // icon: 'lock',
        roles: ["tongzhigonggao"]
      }
    },

    {
      path: "mettingSign",
      component: () => import("@/views/adminMan/mettingSign/index"),
      meta: {
        title: "会议管理",
        roles: ["huiyiguanli"]
      },
      alwaysShow: true,
      children: [
        // 1 会议管理
        {
          path: "meetingManagement",
          component: () =>
            import("@/views/adminMan/mettingSign/meetingManagement"),
          name: "会议发布",
          meta: {
            title: "会议发布",
            roles: ["huiyifabu"]
          }
        },
        // 2 签到统计
        {
          path: "signStatistic",
          component: () => import("@/views/adminMan/mettingSign/signStatistic"),
          name: "签到统计",
          meta: {
            title: "签到统计",
            roles: ["qiandaotongji"]
          }
        },

        {
          path: "setAward/:meetingId",
          name: "设置奖项",
          component: () => import("@/views/adminMan/mettingSign/setAward"),
          hidden: true,
          meta: {
            title: "设置奖项",
            // icon: 'lock',
            roles: ["huiyiguanli"]
          }
        },

        // ///////
        // 0523 会议室预订
        {
          path: "conferenceRoomReservation",
          component: () =>
            import(
              "@/views/adminMan/mettingSign/conferenceRoomReservation/index"
            ),
          name: "会议室预定",
          meta: {
            title: "会议室预定",
            roles: ["huiyishiyuding"]
          }
        },
        // 预订查询
        {
          path: "reservationQuery",
          component: () =>
            import("@/views/adminMan/mettingSign/reservationQuery/index"),
          name: "预定查询",
          meta: {
            title: "预定查询",
            roles: ["yudingchaxun"]
          }
        },
        // 会议室管理
        {
          path: "conferenceRoomMan",
          component: () =>
            import("@/views/adminMan/mettingSign/conferenceRoomMan/index"),
          name: "会议室管理",
          meta: {
            title: "会议室管理",
            roles: ["huiyishiguanli"]
          }
        },
        // 会议室管理
        {
          path: "regularMeetingsMan",
          component: () =>
            import("@/views/adminMan/mettingSign/regularMeetingsMan/index"),
          name: "常规会议管理",
          meta: {
            title: "常规会议管理",
            roles: ["changguihuiyiguanli"]
          }
        }
      ]
    },

    //
    {
      path: "mailList",
      component: () => import("@/views/adminMan/mailList/index"),
      meta: {
        title: "通讯录",
        roles: ["tongxunlu"]
      },
      alwaysShow: true,
      children: [
        {
          path: "mailListMan",
          component: () =>
            import("@/views/adminMan/mailList/mailListMan/index"),
          name: "通讯录管理",
          meta: {
            title: "通讯录管理",
            roles: ["tongxunluguanli"],
            keepAlive: true
          }
        },
        {
          path: "mailList",
          component: () => import("@/views/adminMan/mailList/mailList/index"),
          name: "通讯录",
          meta: {
            title: "通讯录",
            roles: ["tongxunluguanli_web"],
            keepAlive: true
          }
        }
      ]
    },

    // 正确的权限
    {
      path: "complaintsAndSuggestions",
      component: () =>
        import("@/views/adminMan/complaintsAndSuggestions/index"),
      meta: {
        title: "总经理信箱",
        roles: ["tousujianyi"]
      },
      alwaysShow: true,
      children: [
        {
          path: "complaintsAndSuggestionsMan",
          component: () =>
            import(
              "@/views/adminMan/complaintsAndSuggestions/complaintsAndSuggestionsMan"
            ),
          name: "总经理信箱管理",
          meta: {
            title: "总经理信箱管理",
            roles: ["tousujianyiguanli"],
            keepAlive: true
          }
        },
        {
          path: "myComplaintsAndSuggestions",
          component: () =>
            import(
              "@/views/adminMan/complaintsAndSuggestions/myComplaintsAndSuggestions"
            ),
          name: "我的信箱管理",
          meta: {
            title: "我的信箱管理",
            roles: ["wodetousujianyi"],
            keepAlive: true
          }
        }
      ]
    },

    // 流调管理
    {
      path: "flowToneMan",
      name: "流调管理",
      component: () => import("@/views/adminMan/flowToneMan/index"),
      meta: {
        title: "流调管理",
        // icon: 'lock',
        roles: ["liudiaoguanli_web"]
      }
    },

    // 车辆管理
    {
      path: "vehicleMan",
      component: () =>
        import("@/views/adminMan/complaintsAndSuggestions/index"),
      meta: {
        title: "车辆管理",
        // liudiaoguanli_web
        // cheliangguanli_web
        roles: ["cheliangguanli_web"]
      },
      alwaysShow: true,
      children: [
        // 1 车辆管理
        {
          path: "vehicleMan",
          meta: {
            title: "车辆管理",
            roles: ["cheliangguanli"]
          },
          component: () =>
            import("@/views/adminMan/vehicleMan/vehicleMan/index"),
          children: [
            {
              path: "vehicleProfileInformation",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/vehicleMan/vehicleProfileInformation/index"
                ),
              name: "车辆档案信息",
              meta: {
                title: "车辆档案信息",
                roles: ["cheliangdanganxinxi"]
              }
            },
            {
              path: "driverInformation",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/vehicleMan/driverInformation/index"
                ),
              name: "驾驶员信息",
              meta: {
                title: "驾驶员信息",
                roles: ["jiashiyuanxinxi"]
              }
            },
            {
              name: "车辆交接信息",
              path: "vehicleHandoverInformation",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/vehicleMan/vehicleHandoverInformation/index"
                ),
              meta: {
                title: "车辆交接信息",
                roles: ["cheliangjiaojiexinxi"]
              }
            }
          ]
        },
        // 2 维保管理
        {
          path: "maintenanceMan",
          meta: {
            title: "维保管理",
            roles: ["weibaoguanli"]
          },
          component: () =>
            import("@/views/adminMan/vehicleMan/vehicleMan/index"),
          children: [
            {
              path: "vehicleMaintenanceSupervision",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/maintenanceMan/vehicleMaintenanceSupervision/index"
                ),
              name: "车辆维保监审",

              meta: {
                title: "车辆维保监审",
                roles: ["cheliangweibaojianguan"]
              }
            },
            {
              path: "vehicleMaintenanceMan",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/maintenanceMan/vehicleMaintenanceMan/index"
                ),
              name: "车辆维保管理",

              meta: {
                title: "车辆维保管理",
                roles: ["cheliangweibaoguanli"]
              }
            }
          ]
        },
        // 3 旧品回收
        {
          path: "recyclingOfUsedGoods",
          meta: {
            title: "旧件回收",
            roles: ["jiujianhuishou"]
          },
          component: () =>
            import("@/views/adminMan/vehicleMan/recyclingOfUsedGoods/index"),
          children: [
            {
              path: "recyclingOfUsedGoodsMan",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/recyclingOfUsedGoods/recyclingOfUsedGoodsMan/index"
                ),
              name: "旧件回收管理",

              meta: {
                title: "旧件回收管理",
                roles: ["jiujianhuishouguanli"]
              },
              children: []
            },
            {
              path: "saleOfOldPartsAuth",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/recyclingOfUsedGoods/saleOfOldPartsAuth/index"
                ),
              name: "旧件变卖审核",

              meta: {
                title: "旧件变卖审核",
                roles: ["jiujianbianmaishenhe"]
              },
              children: []
            },

            {
              path: "saleReceiptConfirmation",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/recyclingOfUsedGoods/saleReceiptConfirmation/index"
                ),
              name: "变卖收款确认",

              meta: {
                title: "变卖收款确认",
                roles: ["bianmaishoukuanqueren"]
              },
              children: []
            }
          ]
        },

        // 4 年检保险
        {
          path: "annualInspectionInsurance",
          meta: {
            title: "年检保险",
            roles: ["nianjianbaoxian"]
          },
          component: () =>
            import(
              "@/views/adminMan/vehicleMan/annualInspectionInsurance/index"
            ),
          children: [
            {
              path: "carAnnualInspectionMan",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/annualInspectionInsurance/carAnnualInspectionMan/index"
                ),
              name: "车辆年检管理",
              meta: {
                title: "车辆年检管理",
                roles: ["cheliangnianjianguanli"]
              },
              children: []
            },
            {
              path: "carInsuranceMan",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/annualInspectionInsurance/carInsuranceMan/index"
                ),
              name: "车辆保险管理",
              meta: {
                title: "车辆保险管理",
                roles: ["cheliangbaoxianguanli"]
              },
              children: []
            },
            {
              path: "carOutRiskMan",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/annualInspectionInsurance/carOutRiskMan/index"
                ),
              name: "车辆出险管理",
              meta: {
                title: "车辆出险管理",
                roles: ["cheliangchuxianguanli"]
              },
              children: []
            }
          ]
        },

        // 5 费用管理
        {
          path: "costMan",
          meta: {
            title: "费用管理",
            roles: ["feiyongguanli"]
          },
          component: () => import("@/views/adminMan/vehicleMan/costMan/index"),
          children: [
            // 车辆预算维护
            {
              path: "vehicleBudgetMaintenance",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/costMan/vehicleBudgetMaintenance/index"
                ),
              name: "车辆预算维护",
              meta: {
                title: "车辆预算维护",
                roles: ["cheliangyusuanweihu"]
              },
              children: []
            },

            // 加油卡管理
            {
              path: "fuelCardMan",
              component: () =>
                import("@/views/adminMan/vehicleMan/costMan/fuelCardMan/index"),
              name: "加油卡管理",
              meta: {
                title: "加油卡管理",
                roles: ["jiayoukaguanli"]
              },
              children: []
            }
          ]
        },

        // 6 车辆使用
        {
          path: "vehicleUse",
          meta: {
            title: "车辆使用",
            roles: ["cheliangshiyong"]
          },
          component: () =>
            import("@/views/adminMan/vehicleMan/vehicleUse/index"),
          children: [
            {
              path: "applyByCar",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/vehicleUse/applyByCar/index"
                ),
              name: "用车申请",
              meta: {
                title: "用车申请",
                roles: ["yongcheshenqing"]
              },
              children: []
            },
            {
              path: "approveDispatchOfCar",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/vehicleUse/approveDispatchOfCar/index"
                ),
              name: "审批派车",
              meta: {
                title: "审批派车",
                roles: ["shenpipaiche"]
              },
              children: []
            },
            {
              path: "driverSignsBill",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/vehicleUse/driverSignsBill/index"
                ),
              name: "司机签单",
              meta: {
                title: "司机签单",
                roles: ["sijiqiandan"]
              },
              children: []
            },
            {
              path: "mileageTaskMan",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/vehicleUse/mileageTaskMan/index"
                ),
              name: "里程任务管理",
              meta: {
                title: "里程任务管理",
                roles: ["lichengrenwuguanli"]
              },
              children: []
            },

            {
              path: "refuelMan",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/vehicleUse/refuelMan/index"
                ),
              name: "加油管理",
              meta: {
                title: "加油管理",
                roles: ["jiayouguanli"]
              },
              children: []
            },
            {
              path: "vehicleInspection",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/vehicleUse/vehicleInspection/index"
                ),
              name: "车辆检查",
              meta: {
                title: "车辆检查",
                roles: ["cheliangjiancha"]
              },
              children: []
            }
          ]
        },
        // 7 统计分析
        {
          path: "statisticalAnalysis",
          meta: {
            title: "统计分析",
            roles: ["tongjifenxi"]
          },
          component: () =>
            import("@/views/adminMan/vehicleMan/statisticalAnalysis/index"),
          children: [
            {
              path: "mileageCheckInQuery",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/statisticalAnalysis/mileageCheckInQuery/index"
                ),
              name: "里程登记查询",
              meta: {
                title: "里程登记查询",
                roles: ["lichengdengjichaxun"]
              },
              children: []
            },
            {
              path: "departureRecordsQuery",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/statisticalAnalysis/departureRecordsQuery/index"
                ),
              name: "出车记录查询",
              meta: {
                title: "出车记录查询",
                roles: ["chuchejiluchaxun"]
              },
              children: []
            },
            {
              path: "refuelRecordsQuery",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/statisticalAnalysis/refuelRecordsQuery/index"
                ),
              name: "加油记录查询",
              meta: {
                title: "加油记录查询",
                roles: ["jiayoujiluchaxun"]
              },
              children: []
            },

            {
              path: "maintenanceRecordsQuery",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/statisticalAnalysis/maintenanceRecordsQuery/index"
                ),
              name: "维保记录查询",
              meta: {
                title: "维保记录查询",
                roles: ["weibaojiluchaxun"]
              },
              children: []
            },

            {
              path: "annualInspectionInsuranceStatistics",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/statisticalAnalysis/annualInspectionInsuranceStatistics/index"
                ),
              name: "年检保险统计",
              meta: {
                title: "年检保险统计",
                roles: ["nianjianbaoxiantongji"]
              },
              children: []
            },

            {
              path: "vehicleInspectionStatistics",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/statisticalAnalysis/vehicleInspectionStatistics/index"
                ),
              name: "车辆检查统计",
              meta: {
                title: "车辆检查统计",
                roles: ["cheliangjianchatongji"]
              },
              children: []
            },

            {
              path: "vehicleCostStatistics_xz",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/statisticalAnalysis/vehicleCostStatistics_xz/index"
                ),
              name: "车辆费用统计-行政",
              meta: {
                title: "车辆费用统计-行政",
                roles: ["cheliangxingzhengtongjixingzheng"]
              },
              children: []
            },

            {
              path: "vehicleCostStatistics_yy",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/statisticalAnalysis/vehicleCostStatistics_yy/index"
                ),
              name: "车辆费用统计-运营",
              meta: {
                title: "车辆费用统计-运营",
                roles: ["cheliangxingzhengtongjiyunying"]
              },
              children: []
            },

            {
              path: "vehicleComprehensiveStatistics",
              component: () =>
                import(
                  "@/views/adminMan/vehicleMan/statisticalAnalysis/vehicleComprehensiveStatistics/index"
                ),
              name: "车辆综合统计",
              meta: {
                title: "车辆综合统计",
                roles: ["cheliangzonghetongji"]
              },
              children: []
            }
          ]
        }
      ]
    }

    // 删掉 投诉建议，用的通讯录权限
    // {
    //   path: "complaintsAndSuggestions",
    //   component: () => import("@/views/adminMan/complaintsAndSuggestions/index"),
    //   meta: {
    //     title: "投诉建议",
    //     roles: ["tongxunlu"]
    //   },
    //   alwaysShow: true,
    //   children: [
    //     {
    //       path: "complaintsAndSuggestionsMan",
    //       component: () =>
    //         import("@/views/adminMan/complaintsAndSuggestions/complaintsAndSuggestionsMan"),
    //       name: "投诉建议管理",
    //       meta: {
    //         title: "投诉建议管理",
    //         roles: ["tongxunlu"],
    //         keepAlive: true
    //       },
    //     },
    //     {
    //       path: "myComplaintsAndSuggestions",
    //       component: () =>
    //         import("@/views/adminMan/complaintsAndSuggestions/myComplaintsAndSuggestions"),
    //       name: "我的投诉建议",
    //       meta: {
    //         title: "我的投诉建议",
    //         roles: ["tongxunlu"],
    //         keepAlive: true
    //       }
    //     },
    //   ]
    // }
  ]
};

export default adminManRouter;
